import { render, staticRenderFns } from "./HomeBoxPartner.vue?vue&type=template&id=60ab1561"
import script from "./HomeBoxPartner.vue?vue&type=script&lang=js"
export * from "./HomeBoxPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports